// extracted by mini-css-extract-plugin
module.exports = {"page":"info_page_1FOOR","main":"info_main_2CLX_"};